export const initialCard: CardType = {
  name: 'initial',
  src: 'initial',
  src2: 'initial',
  caption: 'initial',
  caption2: 'initial',
}
export type CardType = {
  name: string
  src: string
  src2: string
  caption: string
  caption2: string
}

export type GameContextValue = {
  difficulty: number
  isPaused: boolean
  setIsPaused: React.Dispatch<React.SetStateAction<boolean>>
  iconList: CardType[]
  setIconList: React.Dispatch<React.SetStateAction<CardType[]>>
  iconFoundList: CardType[]
  setIconFoundList: React.Dispatch<React.SetStateAction<CardType[]>>
  firstSelectedCard: CardType
  setFirstSelectedCard: React.Dispatch<React.SetStateAction<CardType>>
  secondSelectedCard: CardType
  setSecondSelectedCard: React.Dispatch<React.SetStateAction<CardType>>
  isCheckingCards: boolean
  setIsCheckingCards: React.Dispatch<React.SetStateAction<boolean>>
  isShowingWinModal: boolean
  setIsShowingWinModal: React.Dispatch<React.SetStateAction<boolean>>
  isCheckWin: boolean
  setIsCheckWin: React.Dispatch<React.SetStateAction<boolean>>
  hoursText: string
  minutesText: string
  secondsText: string
  onStartTimer: () => void
  onStopTimer: () => void
  onPauseTimer: () => void
}
